import SegmentPage from "./SegmentPage";

const config = {
  eyebrow: "Gewerbekunden",
  seoTitle: "Energieberatung für Gewerbe & Industrie",
  titleLines: ["Für Ihr Unternehmen –", 'planbar & <span class="font-serif italic text-blue-700">effizient.</span>'],
  subtitle: "Professionelle Tarifoptimierung für Gewerbe, Hausverwaltungen, Hotels, Praxen und Industrie – SLP wie RLM.",
  path: "/gewerbekunden",
  image: "office",
  sideImage: "industry",
  topic: "gewerbekunden",
  intro: "Ob einzelne Betriebsstätte oder Filialunternehmen mit vielen Zählpunkten: Wir analysieren jeden Vertrag individuell und sorgen für transparente, effiziente Energieversorgung.",
  points: [
    { title: "SLP & RLM Expertise", text: "Individuelle Analyse für Standardlastprofil- und leistungsgemessene Kunden." },
    { title: "Bündelung von Zählpunkten", text: "Mehrere Standorte gebündelt beschafft – spart Zeit, Aufwand und Kosten." },
    { title: "Börsennahe Beschaffung", text: "Zugang zu Konditionen abseits klassischer Portale über passende Partner." },
    { title: "Hausverwaltungen & WEG", text: "Spezialisierte Betreuung für Verwaltungen und Eigentümergemeinschaften." },
    { title: "Alles aus einer Hand", text: "Wechsel, Kündigung und Vertragsabwicklung übernehmen wir komplett." },
  ],
};

export default function Gewerbekunden() {
  return <SegmentPage config={config} />;
}
